var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 29,
    viewBox: "0 0 54 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 29C26.3722 29 25.7439 28.8583 25.2646 28.5752L0.719331 14.0752C-0.239777 13.5086 -0.239777 12.5911 0.719331 12.0249C1.67844 11.4587 3.23154 11.4583 4.19004 12.0249L27 25.4997L49.81 12.0249C50.7691 11.4583 52.3222 11.4583 53.2807 12.0249C54.2392 12.5915 54.2398 13.509 53.2807 14.0752L28.7354 28.5752C28.2561 28.8583 27.6277 29 27 29ZM28.7354 16.9752L53.2807 2.47523C54.2398 1.90865 54.2398 0.991162 53.2807 0.424939C52.3216 -0.141284 50.7685 -0.141646 49.81 0.424939L27 13.8997L4.19004 0.424939C3.23093 -0.141646 1.67783 -0.141646 0.719331 0.424939C-0.239163 0.991525 -0.239777 1.90901 0.719331 2.47523L25.2646 16.9752C25.7439 17.2583 26.3722 17.4 27 17.4C27.6277 17.4 28.2561 17.2583 28.7354 16.9752Z",
    fill: "#751034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.40d8115d0858b76d9f9b1299c8ee98fa.svg";
export { ForwardRef as ReactComponent };